export default "__VITE_ASSET__DiCDsfA4__"